import { render, staticRenderFns } from "./AnticipationHistory.vue?vue&type=template&id=6297c9d5"
import script from "./AnticipationHistory.vue?vue&type=script&lang=js"
export * from "./AnticipationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports